import { useState } from 'react';
import { createTicket } from '../../services/api';

export default function Support() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error' | 'check' | 'check_loading' | 'check_success' | 'check_error'>('idle');
    const [ticketId, setTicketId] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('submitting');

        const result = await createTicket(formData);

        if (result.success && result.ticket_id) {
            setStatus('success');
            setTicketId(result.ticket_id);
            setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        } else {
            setStatus('error');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            {/* Header */}
            <header className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
                    <a href="/" className="flex items-center gap-2">
                        <div className="w-10 h-10 bg-[#2B5BA6] rounded-xl flex items-center justify-center text-white text-xl font-bold">
                            T
                        </div>
                        <span className="text-xl font-bold text-gray-900">TecnosMX</span>
                    </a>

                    <a href="/" className="text-sm font-medium text-gray-600 hover:text-[#2B5BA6] transition-colors">
                        <i className="ri-arrow-left-line mr-1"></i> Volver al Inicio
                    </a>
                </div>
            </header>

            <main className="py-12 px-6">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center mb-12">
                        <div className="inline-block px-4 py-2 bg-[#2B5BA6]/10 rounded-full mb-4">
                            <span className="text-[#2B5BA6] text-sm font-medium">Centro de Soporte</span>
                        </div>
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">¿En qué podemos ayudarte?</h1>
                        <p className="text-lg text-gray-600">
                            Nuestro equipo técnico está listo para resolver cualquier inconveniente con tu servicio.
                        </p>
                    </div>

                    <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
                        <div className="p-8 md:p-12">
                            <div className="flex border-b border-gray-100 mb-8">
                                <button
                                    onClick={() => { setStatus('idle'); setTicketId(''); }}
                                    className={`flex-1 py-4 font-medium text-sm transition-colors border-b-2 ${status !== 'check' ? 'border-[#2B5BA6] text-[#2B5BA6]' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                                >
                                    Nuevo Ticket
                                </button>
                                <button
                                    onClick={() => setStatus('check')}
                                    className={`flex-1 py-4 font-medium text-sm transition-colors border-b-2 ${status === 'check' || status === 'check_loading' || status === 'check_success' || status === 'check_error' ? 'border-[#2B5BA6] text-[#2B5BA6]' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                                >
                                    Consultar Estado
                                </button>
                            </div>

                            {status === 'success' ? (
                                <div className="text-center py-12">
                                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                        <i className="ri-check-line text-4xl text-green-600"></i>
                                    </div>
                                    <h3 className="text-2xl font-bold text-gray-900 mb-4">¡Ticket Recibido!</h3>
                                    <p className="text-gray-600 mb-6">
                                        Hemos registrado tu solicitud correctamente. Tu número de ticket es:
                                    </p>
                                    <div className="bg-gray-100 py-3 px-6 rounded-lg inline-block text-xl font-mono font-bold text-[#2B5BA6] mb-8">
                                        {ticketId}
                                    </div>
                                    <p className="text-sm text-gray-500 mb-8">
                                        Guarda este ID para consultar el estado de tu solicitud.
                                    </p>
                                    <button
                                        onClick={() => { setStatus('idle'); setTicketId(''); }}
                                        className="bg-[#2B5BA6] text-white px-8 py-3 rounded-full font-bold hover:bg-[#234a8a] transition-colors cursor-pointer"
                                    >
                                        Crear otro ticket
                                    </button>
                                </div>
                            ) : status === 'check' || status === 'check_loading' || status === 'check_error' || status === 'check_success' ? (
                                <div className="space-y-6">
                                    {status === 'check_success' && (
                                        <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
                                            <div className="flex justify-between items-start mb-4">
                                                <div>
                                                    <h3 className="font-bold text-gray-900 text-lg">Ticket: {ticketId}</h3>
                                                    <p className="text-sm text-gray-500">Asunto: {formData.subject}</p>
                                                </div>
                                                <span className={`px-3 py-1 rounded-full text-xs font-bold ${formData.name === 'open' ? 'bg-red-100 text-red-700' :
                                                    formData.name === 'closed' ? 'bg-gray-100 text-gray-700' :
                                                        'bg-yellow-100 text-yellow-700'
                                                    }`}>
                                                    {formData.name === 'open' ? 'ABIERTO' : formData.name === 'closed' ? 'CERRADO' : 'PENDIENTE'}
                                                </span>
                                            </div>

                                            <div className="space-y-4 max-h-60 overflow-y-auto mb-6 pr-2">
                                                {/* Messages would be mapped here, but we need to store them in state first. 
                                                    For now, let's just show a summary or the last message if available in formData.message 
                                                    Actually, let's reuse formData.message for the last reply for simplicity in this view 
                                                */}
                                                <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                                    <p className="text-gray-600 text-sm whitespace-pre-wrap">{formData.message || 'Sin mensajes aún.'}</p>
                                                </div>
                                            </div>

                                            <button
                                                onClick={() => setStatus('check')}
                                                className="w-full text-[#2B5BA6] font-medium text-sm hover:underline"
                                            >
                                                Consultar otro ticket
                                            </button>
                                        </div>
                                    )}

                                    {(status === 'check' || status === 'check_loading' || status === 'check_error') && (
                                        <form onSubmit={async (e) => {
                                            e.preventDefault();
                                            setStatus('check_loading');
                                            try {
                                                const res = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost/tecnosmx.com/admin/api'}/tickets.php?ticket_id=${ticketId}`);
                                                const data = await res.json();
                                                if (res.ok) {
                                                    // Map response to state for display
                                                    setFormData({
                                                        ...formData,
                                                        subject: data.subject,
                                                        name: data.status, // abusing name field for status temporarily to avoid new state
                                                        message: data.messages && data.messages.length > 0
                                                            ? data.messages[data.messages.length - 1].message
                                                            : 'Sin respuesta aún.'
                                                    });
                                                    setStatus('check_success');
                                                } else {
                                                    setStatus('check_error');
                                                }
                                            } catch (err) {
                                                setStatus('check_error');
                                            }
                                        }}>
                                            <div>
                                                <label htmlFor="check_id" className="block text-sm font-medium text-gray-700 mb-1">ID del Ticket</label>
                                                <input
                                                    type="text"
                                                    id="check_id"
                                                    required
                                                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all font-mono uppercase"
                                                    placeholder="Ej: TKT-699400..."
                                                    value={ticketId}
                                                    onChange={e => setTicketId(e.target.value)}
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                disabled={status === 'check_loading'}
                                                className="w-full bg-[#2B5BA6] text-white py-4 rounded-xl font-bold text-lg hover:bg-[#234a8a] transition-colors shadow-lg shadow-blue-900/10 flex items-center justify-center gap-2 mt-6"
                                            >
                                                {status === 'check_loading' ? 'Buscando...' : 'Consultar'}
                                            </button>
                                            {status === 'check_error' && (
                                                <p className="text-red-500 text-sm text-center mt-4">No encontramos un ticket con este ID.</p>
                                            )}
                                        </form>
                                    )}
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div className="grid md:grid-cols-2 gap-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nombre Completo</label>
                                            <input
                                                type="text"
                                                id="name"
                                                required
                                                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all"
                                                placeholder="Tu nombre"
                                                value={formData.name}
                                                onChange={e => setFormData({ ...formData, name: e.target.value })}
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Correo Electrónico</label>
                                            <input
                                                type="email"
                                                id="email"
                                                required
                                                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all"
                                                placeholder="tu@email.com"
                                                value={formData.email}
                                                onChange={e => setFormData({ ...formData, email: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all"
                                            placeholder="Para contactarte más rápido"
                                            value={formData.phone}
                                            onChange={e => setFormData({ ...formData, phone: e.target.value })}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">Asunto</label>
                                        <select
                                            id="subject"
                                            required
                                            className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all bg-white"
                                            value={formData.subject}
                                            onChange={e => setFormData({ ...formData, subject: e.target.value })}
                                        >
                                            <option value="">Selecciona un motivo</option>
                                            <option value="Soporte Técnico Internet">Falla de Internet</option>
                                            <option value="Soporte Técnico Equipo">Problema con Equipo</option>
                                            <option value="Facturación">Facturación / Pagos</option>
                                            <option value="Información">Información General</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
                                        <textarea
                                            id="message"
                                            rows={5}
                                            required
                                            className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#2B5BA6] focus:ring-2 focus:ring-[#2B5BA6]/20 outline-none transition-all resize-none"
                                            placeholder="Describe tu problema con detalle..."
                                            value={formData.message}
                                            onChange={e => setFormData({ ...formData, message: e.target.value })}
                                        ></textarea>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={status === 'submitting'}
                                        className={`w-full bg-[#2B5BA6] text-white py-4 rounded-xl font-bold text-lg hover:bg-[#234a8a] transition-colors shadow-lg shadow-blue-900/10 flex items-center justify-center gap-2 ${status === 'submitting' ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'
                                            }`}
                                    >
                                        {status === 'submitting' ? (
                                            <>
                                                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Enviando...
                                            </>
                                        ) : (
                                            <>
                                                Enviar Ticket <i className="ri-send-plane-fill"></i>
                                            </>
                                        )}
                                    </button>

                                    {status === 'error' && (
                                        <div className="p-4 bg-red-50 text-red-600 rounded-xl text-center text-sm font-medium">
                                            Ocurrió un error al enviar el ticket. Por favor intenta nuevamente.
                                        </div>
                                    )}
                                </form>
                            )}
                        </div>

                        <div className="bg-gray-50 px-8 py-6 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
                            <div className="flex items-center gap-2">
                                <i className="ri-shield-check-line text-[#2B5BA6]"></i>
                                <span>Soporte Seguro y Confidencial</span>
                            </div>
                            <div className="flex items-center gap-6">
                                <a href="tel:+529541397099" className="hover:text-[#2B5BA6]">Urgent? Llama al +52 954 139 7099</a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
